var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 1.27273H11.9V0H10.5V1.27273H3.5V0H2.09997V1.27273H1.40003C0.630005 1.27273 0 1.84529 0 2.54545V12.7273C0 13.4274 0.630005 14 1.40003 14H12.6C13.37 14 14 13.4272 14 12.7273V2.54545C13.9999 1.84529 13.3699 1.27273 12.6 1.27273ZM12.6 12.7275H1.40003V5.7274H12.6V12.7275ZM12.6 4.45461H1.40003V2.54545H12.6V4.45461Z",
    fill: "#244277"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderBlue);
export default __webpack_public_path__ + "static/media/Calender_blue.e4c891f3ad6f5eec80d039b0db25641c.svg";
export { ForwardRef as ReactComponent };